import React, {useState} from "react";
import "./AfterSaleService.scss";
import {SubmitInfo} from "../../../../components/SubmitInfo/SubmitInfo";
import {BlackModal} from "../../../../components/BlackModal/BlackModal";
import {FooterFixed} from "../../../../components/FooterFixed";
import {useFixedHeader} from "../../../../utils/headerHelper";
import team2 from "./img/after-block1.jpg";
import team3 from "./img/after-block2.jpg";
import qr from "./img/qr.jpg";
import intl from "react-intl-universal";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";

export function AfterSaleService() {
    useFixedHeader();

    const [showQR, setShowQR] = useState(false);
    const [showPhone, setShowPhone] = useState(false);
    const isCN = LOCALES_HELPER.getLan() === DEFAULT_LOCALE;

    return (
        <div>
            <main className="main-content">
                <header
                    className="page-header large image-background dark-color no-padding service-header-bg center">
                        <div className="container v-align-center">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="x-large">{intl.get('shfw')}</h1>
                                    <div>
                                        <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                        className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                        className="icon-glyph-10 medium"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                </header>


                <section className="pt-medium light-color">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5" style={{marginTop: '100px'}}>
                                <div>
                                    <h1>{isCN && <span>Service purposes</span>}{intl.get('fwzz')}</h1>
                                    <h2>{intl.get('fwzz-detail')}</h2>
                                </div>
                            </div>
                            <div className="col-md-7" style={{height: '358px'}}>
                                <img src={team2} className="img-responsive"
                                     alt="EDENA Premium Website template"/>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pt-medium pb-medium light-color">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7" style={{height: '358px'}}>
                                <img src={team3} className="img-responsive"/>
                            </div>
                            <div className="col-md-5" style={{marginTop: '100px'}}>
                                <div>
                                    <h1>{isCN && <span>Quality Policy</span>}{intl.get('zlfz')}</h1>
                                    <h2>{intl.get('zlfz-detail')}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="parallax image-background image-3 text-light" data-stellar-background-ratio="0.3">
                    <div className="container pt-large pb-large">
                        {/*<div className="row">*/}
                        {/*    <div className="col-md-12">*/}
                        {/*        <h1 className="large"><span>Quality policy</span>愿贴心服务<br/>*/}
                        {/*            成为我们友谊的起点</h1>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="text-center">
                                    <h2><span className="icon-glyph-52 font-52"></span>{intl.get('bxqx')}</h2>
                                    <span className="white-color">{intl.get('bxqx-detail')}</span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="text-center">
                                    <h2><span className="icon-glyph-159 font-52"></span>{intl.get('fwxy')}</h2>
                                    <span className="white-color">{intl.get('fwxy-detail')}</span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="text-center">
                                    <h2><span className="icon-glyph-220 font-52"></span>{intl.get('jszd')}</h2>
                                    <span className="white-color">{intl.get('jszd-detail')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/*<section className="pt-medium pb-medium light-color">*/}
                {/*    <div className="container">*/}
                {/*        <div className="row">*/}
                {/*            <div className="col-md-4">*/}
                {/*                <div className="text-center">*/}
                {/*                    <h2><span className="icon-glyph-52 font-32"></span>保修期限</h2>*/}
                {/*                    <span>主机及配件一年以上保修</span>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*            <div className="col-md-4">*/}
                {/*                <div className="text-center">*/}
                {/*                    <h2><span className="icon-glyph-159 font-32"></span>服务响应</h2>*/}
                {/*                    <span>24小时售后响应</span>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*            <div className="col-md-4">*/}
                {/*                <div className="text-center">*/}
                {/*                    <h2><span className="icon-glyph-220 font-32"></span>技术指导</h2>*/}
                {/*                    <span>在线远程技术指导</span>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</section>*/}


                <SubmitInfo/>
                <BlackModal/>
            </main>
            <FooterFixed/>

            <div className="fixed-contact-wrapper">
                <div className="tel-wrapper">
                    <div className="font-32 contact-icon" onMouseEnter={() => setShowPhone(true)}
                         onMouseLeave={() => setShowPhone(false)}>
                        <span className="icon-glyph-104"></span>
                    </div>
                    <div className={`hot-phone ${showPhone ? 'active' : ''}`}>
                        24小时售后服务热线：<br/>
                        （+86）15360880199
                    </div>
                </div>
                <div className="qr-wrapper">
                    <div className="font-32 contact-icon" onMouseEnter={() => setShowQR(true)}
                         onMouseLeave={() => setShowQR(false)}>
                        <span className="icon-glyph-143"></span>
                    </div>
                    <div className={`qr-code ${showQR ? 'active' : ''}`}>
                        <img src={qr}/>
                    </div>
                </div>
            </div>

        </div>
    )
}
